import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./Testimonials.css";

const Testimonials = ({
    title = "Client Testimonials",
    testimonials = [],
    className = "",
}) => {
    // testimonials - array ?
    const safeTestimonials = Array.isArray(testimonials) ? testimonials : [];
    const slidesCount = safeTestimonials.length;

    //  breakpoints settings
    const breakpoints = {};
    
    if (slidesCount >= 2) {
        breakpoints[768] = {
            slidesPerView: Math.min(2, slidesCount),
        };
    }
    
    if (slidesCount >= 3) {
        breakpoints[1024] = {
            slidesPerView: Math.min(3, slidesCount),
        };
    }

    // Feedback === false
    if (slidesCount === 0) {
        return (
            <section className={`testimonials ${className}`}>
                <h2 className="testimonials-title">{title}</h2>
                <p>No testimonials available.</p>
            </section>
        );
    }

    return (
        <section className={`testimonials ${className}`}>
            <h2 className="testimonials-title">{title}</h2>

            <Swiper
                spaceBetween={30}
                loop={slidesCount > 1}
                slidesPerView={Math.min(1, slidesCount)}
                pagination={{ clickable: true }}
                navigation={slidesCount > 1}
                autoplay={
                    slidesCount > 1
                        ? { delay: 3000, disableOnInteraction: false }
                        : false
                }
                modules={[Pagination, Navigation, Autoplay]}
                className="mySwiper"
                breakpoints={Object.keys(breakpoints).length > 0 ? breakpoints : undefined}
            >
                {safeTestimonials.map((t, i) => (
                    <SwiperSlide key={i}>
                        <article className="testimonial-card">
                            <p className="testimonial-quote">“{t.quote || ""}”</p>
                            <footer className="testimonial-footer">
                                <p className="testimonial-author">{t.author || ""}</p>
                                <p className="testimonial-role">{t.role || ""}</p>
                            </footer>
                        </article>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default Testimonials;